import React from 'react';

import {
	Wrapper,
	Title,
	TableWrapper,
	Table,
	MainHeader,
	Cell,
	SecondaryHeader,
	Row,
} from './TailSpendPreview.styles';

export const TAIL_SPEND_TYPES = {
	percentage: 0,
	value: 1,
	quantity: 2,
	vendorSpend: 3,
};

export const TailSpendPreview = ({
	dateRangeText,
	previewData,
	currencySymbol,
}) => {
	const { harmonized, original } = previewData;

	const segmentsData = harmonized.segmentsData.map((harmonizedSegment, i) => ({
		title: harmonizedSegment.title,
		harmonized: harmonizedSegment,
		original: original.segmentsData[i],
	}));

	const data = [
		{
			title: 'Head',
			harmonized: {
				percentage: harmonized.headSpendPercentage,
				value: harmonized.headSpendValue,
				vendorsCount: harmonized.headVendorsCount,
			},
			original: {
				percentage: original.headSpendPercentage,
				value: original.headSpendValue,
				vendorsCount: original.headVendorsCount,
			},
		},
		{
			title: 'Tail',
			harmonized: {
				percentage: harmonized.tailSpendPercentage,
				value: harmonized.tailSpendValue,
				vendorsCount: harmonized.tailVendorsCount,
			},
			original: {
				percentage: original.tailSpendPercentage,
				value: original.tailSpendValue,
				vendorsCount: original.tailVendorsCount,
			},
		},
		...segmentsData,
	];

	return (
		<Wrapper>
			<Title>Preview</Title>
			<TableWrapper>
				<Table>
					<MainHeader>
						<Cell />
						<Cell>Harmonized vendors</Cell>
						<Cell>Original vendors</Cell>
					</MainHeader>
					<SecondaryHeader>
						<Cell>{dateRangeText}</Cell>
						<Cell>
							<div>
								<span>Percent</span> <span>of spend</span>
							</div>
							<div>Spend value</div>
							<div>Vendors</div>
						</Cell>
						<Cell>
							<div>
								<span>Percent</span> <span>of spend</span>
							</div>
							<div>Spend value</div>
							<div>Vendors</div>
						</Cell>
					</SecondaryHeader>
					{data.map((segment, index) => (
						<Row key={`${segment.title}_${index}`}>
							<Cell>{segment.title}</Cell>
							<Cell>
								<div>{segment.harmonized.percentage}%</div>
								<div
								>{`${currencySymbol}${segment.harmonized.value.toLocaleString()}`}</div>
								<div>{segment.harmonized.vendorsCount}</div>
							</Cell>
							<Cell>
								<div>{segment.original.percentage}%</div>
								<div
								>{`${currencySymbol}${segment.original.value.toLocaleString()}`}</div>
								<div>{segment.original.vendorsCount}</div>
							</Cell>
						</Row>
					))}
				</Table>
			</TableWrapper>
		</Wrapper>
	);
};

export default TailSpendPreview;
